import Vue from "vue";
import { Component, Emit, Prop, Watch } from "vue-property-decorator";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import { Board, Ticket } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";

@Component({
    name: 'MoveComponent',
    components: { vSelect }
})
export default class MoveComponent extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    state!: KanbanState;
    @Prop({ required: true })
    board!: Board;

    private selectedBoard: Board | null = null;
    private selectedFlow: Ticket | null = null;

    mounted(): void {
        this.selectedBoard = this.board;
    }

    private move(): void {
        this.$emit('selected', this.selectedBoard, this.selectedFlow);
    }

    @Emit('close')
    private close(): void { }

    @Watch('selectedBoard')
    private onSelectedBoardChanged(): void {
        let tickets = this.selectedBoard?.tickets;
        this.selectedFlow = (tickets && tickets[0]) ?? null;
    }
}